<template>
  <div v-if="state !== null">
    <div v-for="(error, index) in errors" :key="index">
      <div
        class="
          d-flex
          align-items-center
          justify-content-start
          color_alert
          font_16
        "
        v-if="error.value === false"
      >
        <mdicon name="alert-circle-outline" size="20" />
        <span class="ml-1">
          {{ $lang.errors[error.key] | replace(label, ...error.params) }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
/* guidance: this component is wrapper for vuelidate errors of inputs */

import { startsWith } from "ramda";

export default {
  props: {
    label: {
      // label for show in errors
      type: String,
      default: "",
    },
    vuelidateObj: {
      // vulidate object
      type: Object,
      default: null,
    },
    state: {
      // input state for validation
      type: Boolean,
      default: null,
    },
  },
  computed: {
    errors() {
      /* guidance: generate custom errors array with of vulidate object */

      const data = [];
      const paramsObj = this.vuelidateObj.$params; // get all of current params for

      for (const key of Object.keys(this.vuelidateObj)) {
        if (!startsWith("$", key)) {
          const value = this.vuelidateObj[key];
          let params = [];
          const paramsData = paramsObj[key];
          if (key === "between") {
            // get between params
            params = [paramsData.min, paramsData.max];
          }
          if (key === "minLength") {
            // get min minLength params
            params = [paramsData.min];
          }
          if (key === "maxLength") {
            // get min maxLength params
            params = [paramsData.max];
          }
          // pushing last data generated
          data.push({ key, value, params });
        }
      }
      return data;
    },
  },
};
</script>